<template>
  <div class="inbox-wrapper" v-if="loadingPageOver" :style="[iosOrAndroidStyle, {paddingTop: (isHarmony || isWxMini || isAlipayClient || isUCClient || isQuaReClient) ? '44px' : '100px', background: tabIndex === 0 ? '#ffffff' : ((applicationList&&applicationList.length) ? '#f9f9f9': '#ffffff')}]">
    <open-app @openLinkApp="openLinkApp" v-show="!isWxMini && !isAlipayClient && !isUCClient && !isQuaReClient && loadingPageOver && !showModal" :small-btn="true" />
    <w-nav-bar v-show="iosOrAndroidShow" nav_title="投递邀约" @mobileLeftBtn="back" class="navbar" :style="{top: (isHarmony || isWxMini || isAlipayClient || isUCClient || isQuaReClient) ? '0px' : '56px'}"/>

    <!-- tab -->
    <div class="mailing-tab">
      <div class="mailing-tab-item" :class="{'mailing-tab-item-active': tabIndex === 0}" @click="changeIndex(0)">简历邀约</div>
      <div class="mailing-tab-item" :class="{'mailing-tab-item-active': tabIndex === 1}" @click="changeIndex(1)">已投职位</div>
    </div>

    <!-- 邀约 -->
    <div v-if="tabIndex === 0">

      <w-no-result v-if="noData" text="暂无简历通知"></w-no-result>
      <!-- <div v-if="noData" class="no-data flex-center">暂无简历通知</div> -->
      <div class="inbox-container" v-if="!loadingShow">
        <div v-for="(val,index) in inboxData" :key="index" class="inbox-info" @click="toCompany(val)">
          <div class="job-information flex" v-if="!val.contact">
            <img class="company-logo" :src="val.company_logo || headImgList.square[index % 3 ]" alt="">
            <div class="flex-column job-content">
              <div class="job-post flex-between">
                <span class="post-value">{{ val.job_post }}</span>
                <!-- <span class="job-salary">{{ val.job_salary }}</span> -->
                <span class="job-salary">{{(val.annual_month_salary && val.annual_month_salary > 12) ? `${val.job_salary} · ${val.annual_month_salary}薪` : val.job_salary }}</span>
              </div>
              <div class="company-info flex-between">
                <span class="company-name">{{ val.company_nick_name || val.company }}</span>
                <span class="apply-at">{{ val.apply_at }}</span>
              </div>
            </div>
          </div>
          <div class="hr-information" :class="{'applies-container': val.status === 'applied'}">
            <div class="hr">
              <div class="flex-start">
                <img class="hr-avatar" :src="val.hr_avatar || headImgList.round[index % 3]" alt="">
                <span class="hr-name">{{ val.hr_name }}</span>
                <span class="job-position flex-start">{{ val.hr_company_position }}</span>
              </div>
            </div>
            <div class="company-name" v-if="val.contact">{{ val.company_nick_name || val.company_name }}</div>
            <div class="application-desc color_40 f_14" v-if="val.apply_msg && !val.contact">
              {{val.showMore ? val.apply_msg : val.apply_msg_smail }}<span
                @click.stop="val.showMore = !val.showMore"
                v-if="!val.showMore && val.apply_msg_smail">...<span
                class="more">查看更多</span></span>
            </div>
            <div class="inbox-bottom flex-center" v-if="val.status === 'applied'">
              <div class="left flex-center" @click.stop="reject(val)">不感兴趣</div>
              <div class="right flex-center" @click.stop="apply(val)">发送简历</div>
            </div>
            <div class="inbox-message" v-else-if="val.status === 'passed' && !val.contact">已经表达意向
              <span class="high-light">"可以聊"</span>
            </div>
            <div class="inbox-message" v-else-if="val.status === 'rejected'">已经表达意向 <span class="high-light">"不感兴趣"</span>
            </div>
            <p v-if="val.contact" class="contact-cv">查看了您的简历</p>
          </div>
        </div>
      </div>
      <reject-dialog ref="rejectDialog" :dialog-show="dialogShow" @handleClose="dialogShow = false" :rejectSure="(text) => rejectSure(text)" />
      <w-loading v-if="loadingShow"></w-loading>

    </div>

    <!-- 已投职位 -->
    <div class="list-container" v-if="tabIndex === 1">
      <cube-scroll :data="applicationList" :options="options" @pulling-up="onPullingUp">
        <job-list :list-data="applicationList" :show-update="true"/>
        <w-more-loading v-show="moreShow"></w-more-loading>
        <w-no-more v-show="isEnd"></w-no-more>
      </cube-scroll>
      <w-no-result v-show="noResultState" text="暂无投递职位"></w-no-result>
    </div>
    <send-cv :state="showModal" :cv-data="cvList"  @handleClose="showModal=false" :id="operationItem.id" :job_token="operationItem.job_token"></send-cv>
  </div>
</template>

<script>
	import WNavBar from '../../components/global/w-navbar'
	import WLoading from '../../components/global/w-dialog'
	import WDialog from '../../components/global/w-dialog'
	import WNoResult from '../../components/global/w-no-result'
  import RejectDialog from './RejectDialog'
  import OpenApp from '../../components/cv/open-app'
	import { componentsMixin } from '../../assets/js/mixin/components'
	import { envMixin, loginMixin, downloadAPPMixin } from '../../assets/js/mixin/global'
	import { mapActions, mapMutations, mapState } from 'vuex'
	import { userMixin } from '../../assets/js/mixin/user'
  import {ioMixin} from "../../assets/js/mixin/io";
  import jobList from '../job-components/job-list-mailing'
  import WMoreLoading from '../../components/global/w-more-loading'
  import WNoMore from '../../components/global/w-no-more'
  import SendCv from '../job-components/send-cv.vue'

	let moment = require('moment')

	export default {
		name: 'cv-inbox',
		mixins: [ componentsMixin, envMixin, loginMixin, userMixin, downloadAPPMixin, ioMixin ],
		data () {
			return {
				page: 1,
				loadingShow: true,
				dialogShow: false,
				inboxData: [],
				operationItem: {id:null},
				noData: false,
				headImgList: { //头像
					round: [ 'https://files.wondercv.com/taro_searchResume_miniprogram/headImg_round1.png', 'https://files.wondercv.com/taro_searchResume_miniprogram/headImg_round2.png', 'https://files.wondercv.com/taro_searchResume_miniprogram/headImg_round3.png' ], // 圆图
					square: [ 'https://files.wondercv.com/taro_searchResume_miniprogram/headImg_square1.png', 'https://files.wondercv.com/taro_searchResume_miniprogram/headImg_square2.png', 'https://files.wondercv.com/taro_searchResume_miniprogram/headImg_square3.png' ], // 方图
				},
				onlineState: false,
        tabIndex: 0, // 
        applicationList: [],
        applicationPage: 1,
				applicationTotal: 0,
        options: {
					pullUpLoad: true
				},
        showModal: false
			}
		},
    async created () {
			try {
				await this.loginByWx()
				await this._initLogin()
				this.getUserData()
				this.initOnlineState()
				this._getAllApply()
        this._getApplicationList()
			} catch (e) {
        console.log(e)
			}
      this.getCvList();

    },
		mounted () {
		},
		computed: {
      noResultState () {
				return this.tabIndex === 1 && !this.applicationTotal
			},
      moreShow () {
        return this.applicationList.length < this.applicationTotal
			},
      isEnd () {
        return this.applicationList.length === this.applicationTotal && this.applicationTotal
			},
      ...mapState('cvIndex', [ 'cvList']),
		},
		watch: {},
		components: {
			WNavBar,
			WLoading,
			WDialog,
      OpenApp,
      RejectDialog,
      WNoResult,
      jobList,
      WMoreLoading,
      WNoMore,
      SendCv
		},
		methods: {
			...mapActions('cv', [ 'getOnlineCvData' ]),
			...mapMutations('user', [ 'setIsNeedResume' ]),
      ...mapActions('cvIndex', ['getCvList']),
      // 获取已投职位列表
			async _getApplicationList (init) {
				let res = await this.$api.jobs.getApplicationList({
					page: this.applicationPage,
					page_size: 10
				})
				if (res.code === 1000) {
					this.applicationList = [ ...this.applicationList, ...res.data.application_jobs ]
					this.applicationTotal = res.data.application_job_count
				}
			},
      // 上拉加载
			onPullingUp () {
        console.log('213123')
        if (this.tabIndex === 1 && !this.isEnd) {
					this.applicationPage += 1
					this._getApplicationList()
				}
			},
      // 
      changeIndex (i) {
        this.tabIndex = i
      },
      // 初始化判断是否登录，如果没有登录跳转登录
      _initLogin() {
				let logged = !!this.alreadyLogged
				if (!logged) {
					this.needLogin()
        }
      },
      // 打开APP
      openLinkApp(needReload) {
        let link = {
          ios: `https://www.wondercv.${process.env.VUE_APP_ENV === 'local' ? 'cn' : 'com'}/wondercv_app/open_app?type=other&open_type=inbox`,
          android: `android://h5/open?type=inbox`,
        }
        this.openApp(link, needReload)
      },
			// 返回函数
			back () {
        if (window.history.length > 3){
          this.$router.back()
        } else {
          this.routeTo('/jobs/recommend')
        }
			},
			// 点击拒绝事件
			rejectSure (reasonText) {
				this._operation({
					permission_id: this.operationItem.id,
					operation: 'rejected',
					reason: reasonText
				}, this.operationItem)
				this.dialogShow = false
			},
			// 点击同意
			apply (val) {
				this.operationItem = val
				this._operation({ permission_id: val.id, operation: 'passed' }, val)
        if(this.cvList.length > 1){
          this.showModal = true
        }else if(this.cvList.length == 1){
           this.$api.cv.sendCvToHr(val.id, this.cvList[0].token, {job_token: val.job_token}).then(res => {
            if(res.code == 1000){
              this.toast = this.$createToast({
                txt: '发送成功',
                type: 'txt'
              })
            this.toast.show();
            }else {
              console.log(res.message)
            }
          }).catch(err => {
            console.log(err)
          })
        }
				if (this.onlineState) this.cvDialog(val)
			},
			// 点击拒绝
			reject (val) {
				this.dialogShow = true
				this.operationItem = val
			},
			//获取数据 及 拆分到不同模块
			async _getAllApply () {
				try {
          let res = await this.$api.inbox.getAllApply({ page: this.page, page_size: 10 })
				  let pageClientWidth = document.body.clientWidth
          if (res.code === 1000) {
            let { resume_hr_permissions, resume_hr_permission_count } = res.data
            let maxMsgLength = (pageClientWidth <= 415 && pageClientWidth > 375) ? 38 : 32
            resume_hr_permissions.forEach(item => {
              item.apply_msg_smail = item.apply_msg && item.apply_msg.length > maxMsgLength ? item.apply_msg.substring(0, maxMsgLength) : ''
              item.showMore = !(item.apply_msg && item.apply_msg.length > maxMsgLength)
            })
            if (!resume_hr_permission_count) {
              this.noData = true
            } else {
              this.inboxData = resume_hr_permissions
            }
          } else {
            this.noData = true
            // this.showToast(res.message)
          }
          this.loadingShow = false
        } catch(e) {
          this.noData = true
          this.loadingShow = false
        }
			},
			// 同意或者拒绝的接口
			async _operation (payload, val) {
				let res = await this.$api.inbox.applyOperate(payload.permission_id, payload)
				if (res.code === 1000) {
					if (payload.operation === 'passed') {
						this.showToast('已同意申请')
						val.status = 'passed'
					} else {
						this.showToast('已拒绝申请')
						val.status = 'rejected'
					}
					this.$refs.rejectDialog.reasonText = ''
					this.$refs.rejectDialog.reason.forEach(item => item.status = false)
          this.reportedData({
            data_type: 'job_invite',
            data: {
              permission_ids: [ payload.permission_id ],
              operation: payload.operation
            }
          })
				} else {
					this.showToast(res.msg)
				}
			},
			// 跳转职位或者公司
			toCompany (item) {
				//判断是否有相关联职位 并且职位未过期
				if (item.job_token) {
					this.$router.push({
            path: `/jobs/recommend/${ item.job_token }`,
            query: {
            	companyToken: item.company_token,
              pageSource: 'invitation'
            }
          })
					// this.$router.push(`/jobs/recommend/${ item.job_token }?companyToken=${ item.company_token }`)
				} else if (item.company_token) {
					window.location.href = `/company/${ item.company_token }.html`
				}
			},
			// 公开简历弹窗
			cvDialog (val) {
				this.$createDialog({
					title: '设置HR可见',
					type: 'confirm',
					content: `将简历设置为 HR 可见<br>获得更多职业机会，求职效率翻倍`,
					confirmBtn: {
						text: '立即设置',
					},
					cancelBtn: {
						text: '遗憾错过',
					},
					onConfirm: async () => {
						if (this.userData && !this.userData.match || !this.userData.intention) {
							this.setIsNeedResume(true)
							this.$router.push('/template_matches/new')
						} else {
							this.$router.push('/cvs/online/list')
						}
						this.$db.ls.set(`${ this.cvAccountToken }-inbox`, true)
						// let res = await this.$api.online.createOnlineCv(val.token)
						// if (res.code === 1000) this.showToast('设置成功')
					},
					onCancel: () => {
						this.$db.ls.set(`${ this.cvAccountToken }-inbox`, true)
					}
				}).show()
			},
			// 判断有没有在线简历
			async initOnlineState () {
				let state = this.$db.ls.get(`${ this.cvAccountToken }-inbox`)
				let code = await this.getOnlineCvData(this.cvAccountToken)
				if ((code === 80120) && !state && !this.isIos) this.onlineState = true
			},
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .list-container {
      height: calc(calc(var(--vh, 1vh) * 100) - 90px);
      /deep/ .cube-scroll-list-wrapper {
        padding-bottom: 60px;
      }
      /deep/ .recommend-item {
        padding: 20px 24px;
        margin-bottom: 6px;
        &:first-child {
          padding-top: 16px;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  .inbox-wrapper {
    min-height: 100vh;
    position: relative;
    @include mobile-container(44px, 20px);
    .navbar {
      position: fixed;
      left: 0;
      top: 56px;
    }
    .mailing-tab {
      display: flex;
      align-items: center;
      width: 100vw;
      height: 46px;
      padding: 0 24px;
      background-color: #ffffff;
      .mailing-tab-item {
        color: #9C9C9C;
        margin-right: 24px;
      }
      .mailing-tab-item-active {
        color: #404040;
        font-weight: 500;
      }
    }
    .inbox-container {
      padding: 0 24px;
      .view-height {
        min-height: 165px;
      }
      .wrapper-status {
        height: 0;
        min-height: 0;
        margin-bottom: 0;
        overflow: hidden;
        transition: all .3s;
        transition-delay: .3s;
        .content-status {
          transform: translateX(-100%);
          transition: transform .3s;
        }
      }
      .inbox-info {
        background-color: $color-light;
        padding: 24px 0;
        border-bottom: 1px solid #F8F8FA;
        &:last-child {
          border-bottom: none;
        }
        .job-information {
          margin-bottom: 12px;
          .company-logo {
            width: 40px;
            height: 40px;
            border: 1px solid #F8F8FA;
            border-radius: 4px;
            margin-right: 12px;
            object-fit: cover;
          }
          .job-content {
            flex: 1;
            .job-post {
              margin-bottom: 8px;
              span {
                font-size: $font-size-medium-x;
                color: $color-title;
                font-weight: 500;
              }
              .post-value {
                @include ellipsis(220px)
              }
              .job-salary {
                font-size: $font-size-medium;
                color: $color-theme;
              }
            }
            .company-info {
              color: #9C9C9C;
              .company-name {
                line-height: 16px;
                max-width: 170px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-weight: 300;
              }
              .apply-at {
                font-size: $font-size-small;
                font-weight: 300;
              }
            }
          }
        }
        .hr-information {
          padding: 16px 18px;
          background-color: #F8F8FA;
          border-radius: 6px;
          .hr {
            color: #9c9c9c;
            .hr-avatar {
              width: 22px;
              height: 22px;
              border-radius: 50%;
              margin-right: 10px;
            }
            .job-position {
              &::before {
                content: '';
                display: inline-block;
                width: 1px;
                height: 14px;
                background-color: #9c9c9c;
                margin: 0 6px;
              }
            }
          }
          .contact-cv {
            margin-top: 12px;
            color: #9c9c9c;
          }
          .company-name {
            margin: 12px 0;
            color: #4183FF;
          }
          .application-desc {
            border-radius: 4px;
            line-height: 22px;
            margin: 10px 0 -14px;
            color: $color-dark-gray;
            .more {
              color: #4F658D;
            }
          }
        }
        .applies-container {
          padding-bottom: 0;
        }
        .inbox-bottom {
          height: 45px;
          margin-top: 30px;
          border-top: 1px solid #ececec;
          .left, .right {
            flex: 1;
            margin: 9px 0;
            color: #4183FF;
            height: 27px;
          }
          .left {
            border-right: 1px solid #ECECEC;
            color: $color-dark-gray;
          }
        }
        .inbox-message {
          margin-top: 26px;
          color: #9C9C9C;
          .high-light {
            color: #4183FF;
          }
        }
      }
      .inbox-item {
        margin-bottom: 12px;
        .inbox-header {
          background-color: $color-light;
          padding: 0 18px;
          height: 45px;
          border-bottom: 1px solid #F8F9F9;
          span {
            font-size: $font-size-medium-x;
            font-weight: 500;
          }
          .iconfont {
            color: $color-light-gray;
            font-weight: bold;
          }
        }
      }
    }
    .no-data {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #F8F8FA;
      color: $color-light-gray;
      width: 100vw;
      height: 100%;
    }
    textarea {
      width: calc(90vw - 48px);
      border: 1px solid #dedfe1 !important;
      border-radius: 2px;
      padding: 14px;
      font-size: 14px;
      -webkit-appearance: none;
    }
  }
</style>
